import { bloodyTeddy } from "./index";
import { bloodyTeddyBootDefaults } from "./boot/bootDefaults";
import { launchGame } from "@slot/game-shell";

void launchGame(bloodyTeddy, import.meta.env, bloodyTeddyBootDefaults);
